/**
 * Lazy-loads section background images.
 * Sections below the fold get the `bg-lazy` class server-side (Flexible_Controller::settings_block),
 * which keeps `background-image: none` until the section gets close to the viewport.
 */
export class LazyBackground {

	/** Start loading when the section is one viewport height away */
	static ROOT_MARGIN = '0px 0px 100% 0px';

	static LAZY_CLASS = 'bg-lazy';

	constructor() {
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', this.init.bind(this));
		} else {
			this.init();
		}
	}

	init() {
		const sections = document.querySelectorAll(`.${LazyBackground.LAZY_CLASS}`);
		if (!sections.length) {
			return;
		}

		if (!('IntersectionObserver' in window)) {
			sections.forEach((section) => this.#load(section));
			return;
		}

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				this.#load(entry.target);
				observer.unobserve(entry.target);
			});
		}, { rootMargin: LazyBackground.ROOT_MARGIN });

		sections.forEach((section) => observer.observe(section));
	}

	/** @param {Element} section */
	#load(section) {
		section.classList.remove(LazyBackground.LAZY_CLASS);
	}
}
